import { computed } from '@vue/composition-api'
import { useSettingStore } from '@ms/stores/setting.js'
import { storeToRefs } from 'pinia'
import {
  themeModeValueToNameMap,
  themeTypeValueToNameMap,
  isCurrentPageEnabledTheme
} from '@ms/utils/theme.js'
import { THEME_MODE, THEME_TYPE } from '@ms/config/theme'

/**
 * @typedef {import('./useThemeImagesType').UseThemeImages} UseThemeImages
 */

/** @type {UseThemeImages} */
export const useThemeImages = (options = {}, themeOptions) => {
  if (options == null) {
    throw new Error('options is required')
  }

  const settingStore = storeToRefs(useSettingStore())

  const themeMode = computed(() => {
    if (themeOptions?.value != null) {
      if (themeOptions.value.themeMode === THEME_MODE.SYSTEM.value) {
        return themeOptions.value.systemThemeMode
      }

      return themeOptions.value.themeMode
    }

    if (settingStore.themeMode.value === THEME_MODE.SYSTEM.value) {
      return settingStore.systemThemeMode.value
    }

    return settingStore.themeMode.value
  })

  const themeType = computed(() => {
    if (themeOptions?.value != null) {
      return themeOptions.value.themeType
    }

    return settingStore.themeType.value
  })

  const themeModeName = computed(() => {
    if (!isCurrentPageEnabledTheme.value) {
      return THEME_MODE.DARK.name
    }

    return themeModeValueToNameMap.value.get(themeMode.value)
  })
  const themeTypeName = computed(() => {
    if (!isCurrentPageEnabledTheme.value) {
      return THEME_TYPE.DEFAULT.name
    }

    return themeTypeValueToNameMap.value.get(themeType.value)
  })

  const targetThemeImages = computed(() => {
    const currentThemeMode = options[themeModeName.value]
    if (currentThemeMode == null) {
      return {}
    }

    const currentThemeType = currentThemeMode[themeTypeName.value]
    if (currentThemeType == null) {
      const defaultThemeType = currentThemeMode.default
      if (defaultThemeType == null) {
        return {}
      }

      return defaultThemeType
    }

    return currentThemeType
  })

  return targetThemeImages
}
